/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Field_Address_StreetInputs */

const en_clients_field_address_street = /** @type {(inputs: Clients_Field_Address_StreetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Street`)
};

const pt_br2_clients_field_address_street = /** @type {(inputs: Clients_Field_Address_StreetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logradouro`)
};

/**
* | output |
* | --- |
* | "Street" |
*
* @param {Clients_Field_Address_StreetInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_field_address_street = /** @type {((inputs?: Clients_Field_Address_StreetInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Field_Address_StreetInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_field_address_street(inputs)
	return pt_br2_clients_field_address_street(inputs)
});